/**
 * The `controlUser` operation ids, in a leaf module of their own.
 *
 * They were declared in `./controlUser` beside the schema, and still re-export from there, so
 * nothing that imports them today has to change. The split exists because that file imports the
 * `setColorScheme` / `setLanguage` / `setTheme` / `setUserPreference` BARRELS to assemble its
 * schema, and those barrels re-export React hooks — so reading one enum pulled MUI and the whole
 * component tree in behind it.
 *
 * That matters now because validators have to be loadable outside React: the agent tooling runs
 * them in a Bun server with no DOM. `controlUser`'s validator imports this file rather than the
 * schema for exactly that reason, and the framework's own test suite is what caught it.
 */
export enum UserControlAction {
  SetUserPreference = 'setUserPreference',
  Logout = 'logout',
  UpdateGeolocation = 'updateGeolocation',
  SetLanguage = 'setLanguage',
  // used for setting color scheme (for example: light | dark | system)
  // value is kept as `setTheme` for backward compatibility
  SetColorScheme = 'setTheme',
  // used for setting interface theme (theme id from theme manager is stored)
  SetInterfaceTheme = 'setInterfaceTheme',
  CheckAuth = 'checkAuth',
  RefreshUserContext = 'refreshUserContext',
  SignInWithSSO = 'signInWithSSO',
  TrackLiveLocation = 'trackLiveLocation',
}
